import { Card } from "@/components/ui/card";
import { Trophy, Upload, BookOpen, Users2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Comparison = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";

  const features = [
    {
      icon: Trophy,
      titleKey: "comparison.identifyComplementary",
      descKey: "comparison.identifyComplementaryDesc",
      color: "hsl(280, 85%, 65%)",
    },
    {
      icon: Upload,
      titleKey: "comparison.analyzeTeamDynamics",
      descKey: "comparison.analyzeTeamDynamicsDesc",
      color: "hsl(180, 80%, 55%)",
    },
    {
      icon: BookOpen,
      titleKey: "comparison.fillSkillGaps",
      descKey: "comparison.fillSkillGapsDesc",
      color: "hsl(160, 75%, 50%)",
    },
    {
      icon: Users2,
      titleKey: "comparison.optimizePerformance",
      descKey: "comparison.optimizePerformanceDesc",
      color: "hsl(25, 95%, 60%)",
    },
  ];

  return (
    <section className="relative px-4 py-24 sm:px-6" dir={isRtl ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-7xl">
        <div className="text-center space-y-4 mb-16 animate-fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary/10 border border-secondary/20 backdrop-blur-sm mb-4">
            <Trophy className="w-4 h-4 text-secondary" />
            <span className="text-sm text-secondary font-medium">
              {t('comparison.teamCollaboration')}
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold">
            <span className="text-gradient">{t('comparison.buildBalanced')}</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('comparison.aiComparison')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="group animate-scale-in border-border bg-card p-6 text-start shadow-card transition-all duration-300 hover:border-primary/30 hover:bg-muted hover:shadow-glow"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                  style={{
                    background: `${feature.color}20`,
                  }}
                >
                  <Icon className="w-6 h-6" style={{ color: feature.color }} />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t(feature.descKey)}
                </p>
              </Card>
            );
          })}
        </div>

        <Card className="mt-12 p-8 bg-gradient-primary border-primary/20 shadow-glow animate-slide-up">
          <div className="text-center space-y-4">
            <h3 className="text-2xl font-bold text-foreground">
              {t('comparison.transformTeamDynamics')}
            </h3>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              {t('comparison.transformTeamDynamicsDesc')}
            </p>
          </div>
        </Card>
      </div>
    </section>
  );
};
